import { Alert, Button, Stack, Text } from '@ltvco/refresh-lib/theme';
import { CampaignOutlined } from '@mui/icons-material';

interface DeprecationBannerProps {
  onLearnMoreClick: () => void;
}

export const DeprecationBanner = ({
  onLearnMoreClick,
}: DeprecationBannerProps) => {
  return (
    <Alert
      severity="warning"
      variant="outlined"
      icon={<CampaignOutlined fontSize="inherit" />}
      sx={{
        alignItems: 'center',
        '& .MuiAlert-message': { flex: 1, width: '100%' },
        '& .MuiAlert-action': { alignItems: 'center', mt: 0, pt: 0 },
      }}
      action={
        <Button
          size="small"
          variant="contained"
          color="warning"
          onClick={onLearnMoreClick}
          sx={{ whiteSpace: 'nowrap', alignSelf: 'center' }}
        >
          Learn more
        </Button>
      }
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        spacing={{ xs: 0.25, sm: 1 }}
      >
        <Text variant="body2" sx={{ fontWeight: 700 }}>
          ID Monitor is being deprecated on August 24, 2026.
        </Text>
        <Text variant="body2" sx={{ color: 'text.secondary' }}>
          See what&rsquo;s changing and how it affects your account.
        </Text>
      </Stack>
    </Alert>
  );
};
